import { useEffect } from "react";
import { imageUrl } from "../groupApi";

export function GroupAvatar({ name, image, size = "md" }) {
  const initial = (name || "?").trim().charAt(0);
  return (
    <span className={`grpAvatar grpAvatar-${size}`} aria-hidden="true">
      {image ? <img src={imageUrl(image)} alt="" /> : initial}
    </span>
  );
}

// Bottom sheet on mobile, centered dialog on larger screens.
export function Sheet({ title, onClose, children }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="grpOverlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="grpSheet yekan" role="dialog" aria-modal="true" aria-label={title}>
        <div className="grpSheetHead">
          <h3 className="grpSheetTitle">{title}</h3>
          <button type="button" className="grpIconBtn" onClick={onClose} aria-label="بستن">
            <span className="icon-iconclose"></span>
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function ConfirmSheet({ title, message, confirmLabel, busy, onConfirm, onClose }) {
  return (
    <Sheet title={title} onClose={onClose}>
      <p className="grey-2" style={{ marginTop: 0 }}>{message}</p>
      <div className="grpRowWrap" style={{ marginTop: 16 }}>
        <button type="button" className="grpBtn grpBtn-danger" disabled={busy} onClick={onConfirm}>
          {busy ? "..." : confirmLabel}
        </button>
        <button type="button" className="grpBtn grpBtn-ghost" onClick={onClose}>
          انصراف
        </button>
      </div>
    </Sheet>
  );
}

export function Switch({ checked, disabled, onChange, label }) {
  return (
    <label className="grpSwitch">
      <input type="checkbox" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} aria-label={label} />
      <span></span>
    </label>
  );
}
